import React, { CSSProperties, forwardRef, PropsWithChildren } from 'react'

import { styled } from '@linaria/react'

import { MultiButton } from './MultiButton'

/**
 * Аналогично с Buttons/Like.tsx
 * 1. desktop статичный backgroundImage
 * 2. mobile - scrollEvent, по которому мы меняем backgroundImage
 * 3. Если событие передается то 2. В остальных случаях 1
 */

export const UnionButtons = forwardRef<
  HTMLDivElement,
  PropsWithChildren & { style?: CSSProperties }
>(({ children, style }, ref) => {
  return (
    <Parent ref={ref} style={style}>
      <ParentInner>
        {children} <MultiButton />
      </ParentInner>
    </Parent>
  )
})

const Parent = styled.div`
  position: relative;
  height: 80px;
  width: 152px;
  background-position: 50%;
  padding: 10px;
  margin: -10px;
  box-sizing: content-box;
  transition: background-image 0.01s ease-in-out;
`

/**
 * background-image для кнопок немного смещенен, поэтому здесь отдельный размеры заданы не из темы
 *
 * 1. Нужно попросить поправить дизайнеров поправить background-image позже.
 */
const ParentInner = styled.div`
  display: grid;
  position: relative;
  height: 100%;
  width: 100%;
  padding: 8px 8px 8px 5px;
  grid-template-columns: auto auto;
  justify-content: center;
  align-items: center;
  gap: 22px;
  grid-gap: 22px;
`
